// extracted by mini-css-extract-plugin
export default {"align-items-center":"styles_align-items-center__io0Nn"};